/**
 * RecentTeacherReferredDonor cookie
 * -- set when donor visits a teacher page
 * -- set when donor has a teacher rfParam
 * -- lasts 30 days
 * -- recentTRD
 */
window.setRecentTeacherReferredDonorCookie = function (teacherId, source) {
    window.createCookie('recentTRD', teacherId, 30);
    if (dcAnalytics) {
        dcAnalytics.track('recentTRD', { teacherId, source });
    }
};

function setRecentTeacherReferredDonorCookieBasedOnRFParam() {
    if (window.getRfParamFromQueryStringOrHash(location.href)) {
        const teacherId = window.getRfParamTeacherId();
        if (teacherId && teacherId != userId) {
            window.setRecentTeacherReferredDonorCookie(teacherId, 'rfParam');
        }
    }
}

/**
 *  Used in teacher_profile JS -- note that it only executes if
 *  -- there's no RF Param
 *  -- the referrer is not donorschoose.org
 */
window.setRecentTeacherReferredDonorCookieBasedOnTeacherPage = function (teacherId) {
    if (!teacherId) {
        return;
    }
    teacherId = parseInt(teacherId);
    const isNotSelfReferred = ((!document.referrer) || window.isInterestingReferrer(document.referrer)); // from referredSiteVisit.js
    if (isNotSelfReferred && !window.getRfParamFromQueryStringOrHash(location.href) && !isNaN(teacherId) && teacherId != userId) {
        window.setRecentTeacherReferredDonorCookie(teacherId, pageName);
    }
};

// used in optimizely audience
window.setAndReturnRecentTeacherReferredDonorCookieBasedOnTeacherPage = function (teacherId) {
    if (typeof pageName !== 'undefined' && pageName === 'teacher_profile') {
        window.setRecentTeacherReferredDonorCookieBasedOnTeacherPage(teacherId);
        return readCookie('recentTRD') != null;
    }
    return false;
};

setRecentTeacherReferredDonorCookieBasedOnRFParam();
